import React, { useState} from "react";
import { Card, Button, Divider } from "antd";
import { Calendar, CircleCheck, CircleX, Clock } from "lucide-react";
import HeaderModal from "components/modal/HeaderModal";
import FormItem from "components/fields/FormItem";
import TextArea from "antd/es/input/TextArea";
import LeaveApprovalForm from "./LeaveApprovalForm";


const PendingLeaveRequestCard = (props) => {
  const {
    name,
    role,
    startDate,
    endDate,
    days,
    reason,
    leaveType, 
    dateRequested,
    employeeId,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [action, setAction] = useState("Reject");
  return (
    <Card
      className="rounded-2xl border border-orange-200 hover:border-orange-300 hover:shadow-lg overflow-y-auto space-y-4 pr-2 mb-2"
    >
      <div className="flex justify-between items-start relative">
        <span className={`absolute right-5 text-xs status-indicator ${leaveType.toLowerCase().replace(/\s+/g, "-")}`}>
          {leaveType}
        </span>

        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
            {name ? name.split(" ").map((n) => n[0]).join("") : ""}
          </div>
          <div>
            <div className="flex flex-row gap-2">
              <h3 className="font-semibold text-gray-800 ">{name}</h3>
              <span className="status-indicator normal text-[10px] px-2">{employeeId}</span>
            </div>
         
            <div className="flex items-center text-gray-600 text-sm">
              {role}
            </div>
          </div>
        </div>
      </div>

      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
        <div>
          <p className="text-xs text-gray-500 mb-1">Start Date</p>
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4 text-emerald-600" />
            <span className="text-[13px] font-medium">{startDate}</span>
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">End Date</p>
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4 text-emerald-600" />
            <span className="text-[13px] font-medium">{endDate}</span>
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Duration</p>
          <div className="flex items-center gap-1">
            <Clock className="w-4 h-4 text-purple-600" />
            <span className="text-[13px] font-medium">{days} day{days > 1 ? "s" : ""}</span>
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Submitted</p>
          <span className="text-[13px] font-medium">{dateRequested}</span>
        </div>
      </div>

      <div>
        <p className="text-xs text-gray-500 mb-1">Reason</p>
        <p className="text-[13px] font-medium">{reason}</p>
      </div>

 <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

      <div className="flex gap-3 justify-end">
        <div>
          <Button
            icon={<CircleX size={16}/>}
            onClick={() => {
              setAction("Reject");
              openModal();
            }}
            block
            type="default"
            className="w-full mt-2 btn-reject"
          >
            Reject
          </Button>
        </div>
        <div>
          <Button
            icon={<CircleCheck size={16}/>}
            onClick={() => {
              setAction("Approve");
              openModal();
            }}
            block
            type="default"
            className="w-full mt-2 btn-approve"
          >
            Approve
          </Button>
        </div>
      </div>
            {isModalOpen && (
              <HeaderModal
                open={isModalOpen}
                onClose={closeModal}
                title={`${action} Leave Request`}
                description={`${action} leave request for ${name}?`}
                bgcolor="white"
                width={500}
                footer={
                  <div className="p-4 flex justify-end gap-2">
                    <Button
                      className="inline-flex items-center justify-center gap-2 rounded-xl text-sm text-gray-800 h-9 px-4"
                      onClick={closeModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      className={`btn-${action.toLocaleLowerCase()} alt text-white gap-2 rounded-xl text-sm h-9 px-4`}
                    >
                      {action} Request
                    </Button>
                  </div>
                }
              >
                <LeaveApprovalForm 
                  leaveType={leaveType}
                  days={days}
                  action={action}
                />
              </HeaderModal>
            )}
    </Card>
  );
};

export default PendingLeaveRequestCard;
